import { gql } from '@apollo/client';

import { REPORT_FILE_FRAGMENT, REPORT_FRAGMENT } from './fragments';

export const GET_REPORTS = gql`
  query GetReports($query: IReportInput) {
    getReports(query: $query) {
      data {
        results {
          ...ReportFragment
          last_name
          first_name
          created_at
        }
        total
      }
    }
  }
  ${REPORT_FRAGMENT}
`;

export const GET_REPORT_BY_ID = gql`
  query GetReportById($id: ID!) {
    getReportById(id: $id) {
      data {
        ...ReportFragment
        lang
        email
        signature
        last_name
        first_name
        created_at
        updated_at
        doctor_info
        date_of_birth
      }
    }
  }
  ${REPORT_FRAGMENT}
`;

export const GET_APPOINTMENT_WITH_REPORT = gql`
  query AppointmentsWithReport($query: IReportsInput!) {
    appointmentsWithReport(query: $query) {
      data {
        total
        results {
          id
          patient {
            id
            first_name
            last_name
          }
          report {
            ...ReportFragment
            last_name
            first_name
          }
          reports_file {
            ...ReportFileFragment
          }
        }
      }
    }
  }
  ${REPORT_FRAGMENT}
  ${REPORT_FILE_FRAGMENT}
`;
